import React from 'react'
import PropTypes from 'prop-types'
import firebase from 'services/firebase'

import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

import ParticleBackground from 'components/Layout/ParticleBackground'
import EditDialog from 'components/Dialogs/EditDialog'

import { loginSchema } from 'constants/schemas'
import styles from './styles'

class Login extends React.Component {
  state = {
    processing: false,
    authFailed: false
  }

  handleSubmit = ({ email, password }) => {
    this.setState({ processing: true, authFailed: false })
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .catch(error => {
        this.setState({ processing: false, authFailed: true })
      })
  }

  render() {
    const { classes, title, loading } = this.props
    const { processing, authFailed } = this.state

    return (
      <ParticleBackground>
        <Typography variant="headline" className={classes.title}>
          {title}
        </Typography>
        <EditDialog
          card
          errorMessage={authFailed && 'Authentication failed'}
          fields={loginSchema}
          loading={processing || loading}
          noTitle
          submitLabel="Login"
          update={this.handleSubmit}
        />
      </ParticleBackground>
    )
  }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Login)



// WEBPACK FOOTER //
// ./src/views/Login/Main/index.jsx